module.exports = __webpack_public_path__ + "static/map_horizontal_usa-07f8e0a9b55cd261a81846d21b81e9f2.png";